import { FC } from 'react';

import { PrefecturesWithAll } from '@constants_iqfu';

type Props = {
  location: number;
  count: number;
  number: string;
};

const LicenseNumber: FC<Props> = ({ location, count, number }) => {
  const convertLocationText = (location: number) => {
    if (location === 99) {
      return '国土交通大臣免許';
    } else {
      return PrefecturesWithAll[location] + '知事免許';
    }
  };
  return (
    <>
      {convertLocationText(location)}（{count}）{number}号
    </>
  );
};

export default LicenseNumber;
